import { defineComponent as _defineComponent } from 'vue'

const __default__ = {}

import OzAlertDialogBox from '@@/library/v4/components/OzAlertDialogBox.vue'
import OzOverlay from '@@/library/v4/components/OzOverlay.vue'
import { useGlobalAlertDialogStore } from '@@/pinia/global_alert_dialog'
import { storeToRefs } from 'pinia'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'GlobalAlertDialog',
  setup(__props) {

/**
 * @file This component comes as a pair with the global_alert_dialog Pinia store.
 */
const globalAlertDialogStore = useGlobalAlertDialogStore()
const { isOpen, alertDialogData } = storeToRefs(globalAlertDialogStore)
const { closeAlertDialog } = globalAlertDialogStore

return { __sfc: true,globalAlertDialogStore, isOpen, alertDialogData, closeAlertDialog, OzAlertDialogBox, OzOverlay }
}

})